









import mixins from 'vue-typed-mixins';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { OperationsMixin } from '@/main/mixins/operations';

import { store } from '../../store/edit';
import { ZAKAZKA_DRUH } from '../../constants';

export default mixins(PageModeMixin, OperationsMixin).extend({
	name: 'ZakazkaInterniSkupinaProfilSelect',
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		zakaznikSkDisabled() {
			return (this.isViewMode && !this.canProcess) || (this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND && this.isZakazkaDisabled);
		},
	},
	watch: {
		IntZakaznikSk() {
			this.interniZakaznickaSkupinaChange();
		},
		IntFakturaceprofilId() {
			this.interniFakturacniProfilChange();
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
